import React from 'react';
import SignUpText from './SignUpTextOnScreen';

export default function App(props) {
  
  var width = props.width;
  var height = props.height;
  var extraScreen = props.extraScreen;
  var setExtraScreenSet = props.setExtraScreenSet;
  var clickBack = props.clickBack;
  var logInScreen;
  var title;
  if (extraScreen.v === "logIn" && extraScreen.userSubdomainID === -1){
    title = "Sign Up / Log In";
    logInScreen = <SignUpText key={"login"} updateUserInfo={extraScreen.post} subdomainID={extraScreen.subdomainID} setExtraScreenSet={setExtraScreenSet}/>
  }

  const popUpStyle = {
    position:'fixed',
    left: '0px',
    top:'0px', 
    width, 
    height,
    backgroundColor:'rgba(1,1,1,0.8)',
    verticalAlign:'middle',
    zIndex:30,
  }

  function absorbClick(e){
    e.stopPropagation();
  }

  var titleLine;
  if (title){
    titleLine = <span style={{color:"#46ca99", fontSize:"1.5em", fontWeight:"bolder", whiteSpace:"nowrap"}}>{title}</span>
  }
//
  return <table key={0} style={popUpStyle}><tbody>
        <tr  onClick={clickBack}>
          <td width="50%"><div style={{height}}></div></td>
          <td >
            <div width="100%" onClick={absorbClick} style={{backgroundColor:"white", maxHeight:height*0.9,overflowY:"auto", padding:"20px"}} align="right">
              <button onClick={clickBack}>X</button>
              <center>
                {titleLine}
                <div><br/></div>
                {logInScreen}
              </center>
            </div>
          </td>
          <td width="50%" ></td>
          </tr>
          </tbody>
      </table>  
}
